<div class="ipm-change-password-section">
    <!-- Initiate State -->
    <ng-container *ngIf="viewState === 'initiate'">
        <div class="ipm-heading-model-section">
            <h3>Update Email</h3>
            <div class="ipm-close-icon" (click)="closeByDeviceType()">
                <i class="pi pi-times"></i>
            </div>
        </div>
        <div class="ipm-change-password-body" #initiateFormContainer>
            <div class="error-message-data" *ngIf="shakeAnimation.errorMessage">
                {{shakeAnimation.errorMessage}}
            </div>
            <p class="ipm-sub-heading">
                Please enter your new email address.
            </p>
            
            <form [formGroup]="emailForm" class="custom-form m-0" (keydown.enter)="$event.preventDefault()">
                <div class="form-group custom-form-group">
                    <input type="email" class="form-control" name="newEmail" formControlName="newEmail"
                        [class.ipm-error-border]="emailForm.controls['newEmail'].invalid && emailForm.controls['newEmail'].touched"
                        placeholder="New Email Address"
                        required>
                    <div class="ipm-error-icon" *ngIf="emailForm.controls['newEmail'].invalid && emailForm.controls['newEmail'].touched">
                        <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                    </div>
                    <div class="help-block error-message" *ngIf="emailForm.controls['newEmail'].invalid && emailForm.controls['newEmail'].touched">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        {{formService.getErrorMessage(emailForm.controls['newEmail'], 'Email Address')}}
                    </div>
                </div>

                <div class="ipm-actions">        
                    <button mat-flat-button 
                            color="primary"
                            class="primary-button ipm-submit-btn"
                            type="button"
                            (click)="initiateEmailUpdate(initiateFormContainer.className)"
                            [disabled]="emailForm.invalid">
                        Send OTP
                    </button>
                </div>
            </form>
        </div>
    </ng-container>

    <!-- Verify State -->
    <ng-container *ngIf="viewState === 'verify'">
        <ipm-otp-page 
            [userInfo]="OTPInputData" 
            [errorMessage]="errorMessage" 
            [type]="'emailOtp'"
            [dialogClassName]="'ipm-change-password-model'"
            (closingOtpPopup)="onVerifyOtp($event)" 
            (onClickResendOtpEvent)="onResendOtp()">
        </ipm-otp-page>
    </ng-container>
</div>
